import { TransactionView } from '../../types/entity-types';

// AI enrichment is considered in progress if a proportion of more than 10% of transactions lack a vendorId.
// The promise of AI is that all transactions will be enriched with vendor and category details
const NULL_VENDOR_ID_RATIO_THRESHOLD = 0.1;

export const isAiEnrichmentInProgress = (transactions: TransactionView[]) => {
  if (transactions.length === 0) {
    return false;
  }

  const transactionsWithNullVendorId = transactions.filter((t) => !t.vendorId);
  const nullVendorIdRatio = transactionsWithNullVendorId.length / transactions.length;

  return nullVendorIdRatio < NULL_VENDOR_ID_RATIO_THRESHOLD ? false : true;
};
